import React from 'react';
import { Button, Card, CardHeader } from '@opendate-app/setlist';
import { selectBriefInsights } from '../../utils/dashboardUtils';
import { gridStyle } from './layout';

const openConductor = (prompt) => {
  window.dispatchEvent(new CustomEvent('openConductor', { detail: prompt ? { prompt, source: 'dashboard_brief' } : { source: 'dashboard_brief' } }));
};

function ConductorBrief({ insights, isMobile }) {
  const items = selectBriefInsights(insights);
  if (items.length === 0) return null;

  return (
    <div style={{ marginBottom: 16 }}>
      <Card
        header={(
          <CardHeader
            title="Conductor brief"
            supportingText="What needs your attention"
            actions={<Button variant="link-color" size="sm" onClick={() => openConductor()}>Ask a follow-up</Button>}
          />
        )}
      >
        <div style={{ ...gridStyle(isMobile, `repeat(${items.length}, minmax(0, 1fr))`), marginBottom: 0 }}>
          {items.map((insight) => (
            <div
              key={insight.id}
              style={{ border: '1px solid var(--sl-border-secondary)', borderRadius: 8, padding: 16, display: 'flex', flexDirection: 'column', gap: 8 }}
            >
              <strong style={{ color: 'var(--sl-text-primary)' }}>{insight.title}</strong>
              {insight.body && <span style={{ color: 'var(--sl-text-secondary)', fontSize: 14 }}>{insight.body}</span>}
              {insight.prompt && (
                <div style={{ marginTop: 'auto' }}>
                  <Button variant="link-color" size="sm" onClick={() => openConductor(insight.prompt)}>Ask Conductor</Button>
                </div>
              )}
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}

export default ConductorBrief;
